export default __webpack_public_path__ + "static/media/JanDom2024.d9cf363a.png";